import { AuthProvider, LanguageProvider, ErrorBoundary } from '@/shared';
import { AppRouter } from './router';
import './i18n/config';

/**
 * Root App component with global providers and routing.
 */
function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
